import { usePharmacyId } from '~shared/routes';

import { NOTIFICATION_SOUND_URL } from './constants';
import { useNotificationHandler } from './useNotificationsHandler';
import { useNotificationsSocket } from './useNotificationsSocket';
import { useResetTitleOnVisible } from './useResetTitleOnVisible';

interface NotificationsManagerProps {
  onNotificationHandled: () => void;
}

export function NotificationsManager({
  onNotificationHandled,
}: NotificationsManagerProps) {
  const pharmacyId = usePharmacyId();

  const { handleNotification, audioRef } = useNotificationHandler({
    pharmacyId,
    onNotificationHandled,
  });

  useNotificationsSocket({
    pharmacyId,
    onMessage: handleNotification,
  });

  useResetTitleOnVisible('Mon Backoffice');

  return <audio ref={audioRef} src={NOTIFICATION_SOUND_URL} preload="auto" />;
}
